import { Nav, Navbar, Overlay, Tooltip } from 'react-bootstrap'
import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { isTabletOrMobileQuery, isTabletOrSmallDesktopQuery } from '../../utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMediaQuery } from 'react-responsive'
import NavBadges from './NavBadges'

const MainNavbar = () => {
  const { data: institution, loaded: institutionLoaded } = useSelector(
    (state: RootState) => state.institution,
  )
  const { data: program, loaded: programLoaded } = useSelector(
    (state: RootState) => state.program,
  )

  const { baseUrl } = useSelector((state: RootState) => state.misc)

  const isTabletOrMobile = useMediaQuery(isTabletOrMobileQuery)
  const isTabletOrSmallDesktop = useMediaQuery(isTabletOrSmallDesktopQuery)
  const [open, setOpen] = useState(false)

  const target = useRef<any>(null)
  const [show, setShow] = useState(false)

  if (isTabletOrMobile) {
    return (
      <>
        <Navbar
          collapseOnSelect
          bg='primary'
          expand='xl'
          variant='dark'
          aria-label='Oberer Navigationsbalken'
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Navbar.Brand
              href='#main-content'
              onMouseOver={() => setShow(!show)}
              aria-label='Leitet Sie zu dem einzigartigen Inhalt dieser Seite'
            >
              <div ref={target}>
                <FontAwesomeIcon icon='chevron-down' role='presentation' />
              </div>
              <Overlay target={target.current} show={show} placement='bottom'>
                {(props: any) => (
                  <Tooltip {...props}>
                    Leitet Sie zu dem einzigartigen Inhalt dieser Seite
                  </Tooltip>
                )}
              </Overlay>
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls='responsive-navbar-nav'
              aria-expanded={open}
              onClick={() => setOpen(!open)}
              label='Navigation ein -/ausblenden'
            />
          </div>
          <Navbar.Collapse id='responsive-navbar-nav navbar-toggleable-lg'>
            <Nav className='ml-auto'>
              <Nav.Link
                href={`${baseUrl}/hilfe`}
                className='text-white'
              >
                <FontAwesomeIcon icon='question-circle' role='presentation' />{' '}
                Hilfe
              </Nav.Link>
              {institution.show_pass_resend_form && (
                <Nav.Link
                  href={`${baseUrl}/programm/veranstaltungspass`}
                  className="text-white"
                >
                  <FontAwesomeIcon icon="address-card" role="presentation" />{' '}
                  Veranstaltungspass verloren?
                </Nav.Link>
              )}
              <Nav.Link href={`${baseUrl}/admin/`} className='text-white'>
                <FontAwesomeIcon icon='sign-in-alt' role='presentation' />{' '}
                Verwaltung
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
          <Navbar.Brand
            href={baseUrl}
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
            aria-label='Zurück zur Startseite'
            className='mobile-nav-fixes mt-3 border-top border-bottom'
            title={programLoaded ? program.name : '?'}
          >
            <FontAwesomeIcon icon='home' role='presentation' />{' '}
            {programLoaded ? program.name : '?'}
          </Navbar.Brand>
        </Navbar>
        <Navbar expand='xl' variant='light' bg='primary' className={"px-3 py-0 pb-2"}>
            <NavBadges
              program={program}
              isTabletOrSmallDesktop={isTabletOrSmallDesktop}
            />
        </Navbar>
      </>
    )
  } else {
    return (
      <>
        <Navbar
          collapseOnSelect
          bg="primary"
          expand="xl"
          variant="dark"
          aria-label="Oberer Navigationsbalken"
          role="status"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Navbar.Brand
              href="#main-content"
              onMouseOver={() => setShow(!show)}
              aria-label="Leitet Sie zu dem einzigartigen Inhalt dieser Seite"
            >
              <div ref={target}>
                <FontAwesomeIcon icon="chevron-down" role="presentation" />
              </div>
              <Overlay target={target.current} show={show} placement="bottom">
                {(props: any) => (
                  <Tooltip {...props}>
                    Leitet Sie zu dem einzigartigen Inhalt dieser Seite
                  </Tooltip>
                )}
              </Overlay>
            </Navbar.Brand>

            <Navbar.Brand href={baseUrl}
                          aria-label="Zurück zur Startseite"
                          style={{
                            marginLeft: "8px",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            textAlign: "center",
                            display: "block"
                          }}
            >
              <FontAwesomeIcon icon="home" role="presentation" />{" "}
              {institutionLoaded ? institution.name : "?"}
              {programLoaded ? ` - ${program.name}` : "?"}
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="responsive-navbar-nav" />

            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="ml-auto">
                <Nav.Link href={`${baseUrl}/hilfe`} className="text-white">
                  <FontAwesomeIcon icon="question-circle" role="presentation" />{" "}
                  Hilfe
                </Nav.Link>
                {institution.show_pass_resend_form && (
                  <Nav.Link
                    href={`${baseUrl}/programm/veranstaltungspass`}
                    className="text-white"
                  >
                    <FontAwesomeIcon
                      icon="address-card"
                      role="presentation"
                    />{" "}
                    Veranstaltungspass verloren?
                  </Nav.Link>
                )}
                <Nav.Link href={`${baseUrl}/admin/`} className="text-white">
                  <FontAwesomeIcon icon="sign-in-alt" role="presentation" />{" "}
                  Verwaltung
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </div>
          {isTabletOrSmallDesktop && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "8px",
                width: "100%",
              }}
            >
              <NavBadges
                program={program}
                isTabletOrSmallDesktop={isTabletOrSmallDesktop}
              />
            </div>
          )}
        </Navbar>
      </>
    );
  }
}

export default MainNavbar
